// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import dataTableStyles from "@sc/App/SharedStyles/MyAccountPages/List/DataTableStyles";
import { listStyles } from "@sc/Overrides/Widgets/MyLists/MyListsList";
import { xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

listStyles.messageText = {
    ...dataTableStyles.noResultsText,
};

listStyles.notifyWrapper = {
    css: css`
        width: 100%;
        display: flex;
        align-items: flex-start;
    `,
};

listStyles.cardList = {
    gridContainer: {
        gap: 0,
        css: css`
            border-bottom: 1px solid ${getColor("common.border")};
        `,
    },
};

listStyles.cardContainer = {
    cardDivider: {
        css: css`
            width: 100%;
            margin: 0;
            background: ${getColor("common.white")};
            border: 1px solid ${getColor("common.border")};
            padding: 12px;
            margin-bottom: 20px;
            border-radius: 4px;
        `,
    },
    gridItem: {
        width: 12,
        css: css`
            padding: 0;
        `,
    },
};

listStyles.wishListCardStyles = {
    extendedInfoGridItem: {
        width: [12, 12, 6, 6, 6],
        css: css`
            ${xScreen("lte", "sm")} {
                margin-bottom: 10px;
            }
        `,
    },
    basicInfoGridItem: {
        width: [12, 12, 6, 6, 6],
    },

    sharingStatusGridItem: {
        css: css`
            padding-bottom: 12px;
        `,
    },
    detailLink: {
        typographyProps: {
            css: css`
                line-height: 19px;
            `,
        },
    },

    descriptionText: {
        css: css`
            font-size: 10px;
            line-height: 16px;
            min-height: auto;
        `,
    },
    basicInfoGridContainer: {
        gap: 8,
    },
    lastUpdatedText: {
        css: css`
            & {
                ${xScreen("gte", "md")} {
                    min-height: auto;
                }
                margin-bottom: 4px;
            }
        `,
    },
    actionFavoriteClickable: {
        css: css`
            width: fit-content;
            display: flex;
            white-space: nowrap;
        `,
    },
    starIcon: {
        color: "primary.main",
    },
    actionGridItem: {
        css: css`
            &::before {
                left: 2px;
                right: 2px;
            }
        `,
    },
};
